import { NotificationsState, RootState } from '@/store/types';
import { Module } from 'vuex';
import { ApiService } from '@/services/ApiService';
import { UserNotificationsApi } from '@eurogast/hub-client-typescript';

export default {
  namespaced: true,
  state: {
    unreadCount: 0,
  },
  getters: {
    getUnreadCount(state: NotificationsState) {
      return state.unreadCount;
    },
  },
  mutations: {
    setUnreadCount(state: NotificationsState, unreadCount: number) {
      state.unreadCount = unreadCount;
    },
  },
  actions: {
    async fetchUnreadCount({ commit }) {
      try {
        const unreadCount = await ApiService.wrap(UserNotificationsApi).findUnreadNotificationCount();
        commit('setUnreadCount', unreadCount);
      } catch (e) {
        await ApiService.defaultErrorHandler(e);
      }
    },
  }
} as Module<NotificationsState, RootState>;
